module.exports = "<div class=\"checkbox\">\n\t<label>\n\t\t<input type=\"checkbox\"\n           class=\"formly-field-checkbox\"\n\t\t       ng-model=\"model[options.key]\">\n\t\t{{to.label}}\n\t\t{{to.required ? '*' : ''}}\n\t</label>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./types/checkbox.html
 ** module id = 20
 ** module chunks = 0
 **/